import React from 'react';

const CarWashPrivacy = () => {
  return (
    <div style={{ 
      maxWidth: '800px', 
      margin: '0 auto', 
      padding: '20px', 
      fontFamily: 'Arial, sans-serif',
      lineHeight: '1.6',
      color: '#333'
    }}>
      <h1 style={{ color: '#2c3e50', borderBottom: '2px solid #3498db', paddingBottom: '10px' }}>
        Car Wash: Wash Simulator - Privacy Policy
      </h1>
      
      <p style={{ fontSize: '14px', color: '#7f8c8d', marginBottom: '30px' }}>
        Last updated: {new Date().toLocaleDateString('en-US')}
      </p>

      <section style={{ marginBottom: '30px' }}>
        <h2 style={{ color: '#34495e', marginTop: '30px' }}>1. Introduction</h2>
        <p>
          Car Wash: Wash Simulator ("we", "our", or "us") respects your privacy and is committed to protecting 
          your personal information. This Privacy Policy explains how we handle information in our mobile game application.
        </p>
      </section>

      <section style={{ marginBottom: '30px' }}>
        <h2 style={{ color: '#34495e', marginTop: '30px' }}>2. Information We Collect</h2>
        
        <h3 style={{ color: '#2980b9', fontSize: '18px' }}>2.1 Personal Information</h3>
        <p>
          We do <strong>NOT</strong> collect, store, or process any personal information such as:
        </p>
        <ul style={{ paddingLeft: '30px' }}>
          <li>Names, email addresses, or phone numbers</li>
          <li>Location data</li>
          <li>Photos, contacts, or device storage</li>
          <li>User accounts or login credentials</li>
        </ul>

        <h3 style={{ color: '#2980b9', fontSize: '18px' }}>2.2 Game Data</h3>
        <p>
          All game progress, settings, and achievements are stored <strong>locally on your device only</strong>. 
          This data never leaves your device and is completely under your control.
        </p>
      </section>

      <section style={{ marginBottom: '30px' }}>
        <h2 style={{ color: '#34495e', marginTop: '30px' }}>3. Third-Party Services</h2>
        
        <h3 style={{ color: '#2980b9', fontSize: '18px' }}>3.1 AdMob by Google</h3>
        <p>
          Our app displays advertisements through Google AdMob. AdMob may collect and process certain information 
          to provide personalized ads. This includes:
        </p>
        <ul style={{ paddingLeft: '30px' }}>
          <li>Device identifiers (such as Android Advertising ID)</li>
          <li>IP address</li>
          <li>Device information (model, OS version)</li>
          <li>App usage data for ad targeting</li>
        </ul>

        <h3 style={{ color: '#2980b9', fontSize: '18px' }}>3.2 AdMob Privacy</h3>
        <p>
          Google AdMob is governed by Google's Privacy Policy. You can learn more about how Google uses data at:
        </p>
        <ul style={{ paddingLeft: '30px' }}>
          <li><a href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer">Google Privacy Policy</a></li>
          <li><a href="https://support.google.com/admob/answer/6128543" target="_blank" rel="noopener noreferrer">AdMob Privacy Information</a></li>
        </ul>

        <h3 style={{ color: '#2980b9', fontSize: '18px' }}>3.3 Ad Personalization</h3>
        <p>
          You can opt out of personalized advertising by:
        </p>
        <ul style={{ paddingLeft: '30px' }}>
          <li><strong>Android:</strong> Go to Settings → Google → Ads → Opt out of Ads Personalization</li>
          <li><strong>iOS:</strong> Go to Settings → Privacy → Apple Advertising → Turn off Personalized Ads</li>
        </ul>
      </section>

      <section style={{ marginBottom: '30px' }}>
        <h2 style={{ color: '#34495e', marginTop: '30px' }}>4. Children's Privacy</h2>
        <p>
          Our app is designed to be family-friendly and safe for children. We comply with COPPA (Children's Online Privacy Protection Act):
        </p>
        <ul style={{ paddingLeft: '30px' }}>
          <li>We do not knowingly collect personal information from children under 13</li>
          <li>We do not require personal information to play the game</li>
          <li>All advertisements are family-friendly</li>
          <li>No social features or communication capabilities</li>
          <li>No in-app purchases</li>
        </ul>
      </section>

      <section style={{ marginBottom: '30px' }}>
        <h2 style={{ color: '#34495e', marginTop: '30px' }}>5. Data Security</h2>
        <p>
          Since we don't collect personal data, there's minimal privacy risk. However, we ensure:
        </p>
        <ul style={{ paddingLeft: '30px' }}>
          <li>The app runs entirely offline (except for ads)</li>
          <li>Game data is stored securely on your device</li>
          <li>We use secure connections for ad delivery</li>
          <li>Regular security updates are provided</li>
        </ul>
      </section>

      <section style={{ marginBottom: '30px' }}>
        <h2 style={{ color: '#34495e', marginTop: '30px' }}>6. Your Rights and Choices</h2>
        <p>You have the following rights regarding your privacy:</p>
        <ul style={{ paddingLeft: '30px' }}>
          <li><strong>Data Control:</strong> All game data is stored locally and can be deleted by uninstalling the app</li>
          <li><strong>Ad Preferences:</strong> You can opt out of personalized ads in your device settings</li>
          <li><strong>App Permissions:</strong> Our app requests minimal permissions necessary for functionality</li>
        </ul>
      </section>

      <section style={{ marginBottom: '30px' }}>
        <h2 style={{ color: '#34495e', marginTop: '30px' }}>7. App Permissions</h2>
        <p>Our app may request the following permissions:</p>
        <ul style={{ paddingLeft: '30px' }}>
          <li><strong>Internet Access:</strong> Required for displaying advertisements only</li>
          <li><strong>Network State:</strong> To check internet connectivity for ads</li>
        </ul>
        <p>We do not request access to camera, microphone, contacts, location, or storage.</p>
      </section>

      <section style={{ marginBottom: '30px' }}>
        <h2 style={{ color: '#34495e', marginTop: '30px' }}>8. Data Retention</h2>
        <p>
          Since we don't collect personal data, there's no data retention policy needed. 
          All game progress is stored locally on your device and will be permanently deleted 
          when you uninstall the app.
        </p>
      </section>

      <section style={{ marginBottom: '30px' }}>
        <h2 style={{ color: '#34495e', marginTop: '30px' }}>9. International Users</h2>
        <p>
          This app is available globally. Since we don't collect personal data, 
          international data transfer regulations don't apply. AdMob's data practices 
          are governed by Google's global privacy policies.
        </p>
      </section>

      <section style={{ marginBottom: '30px' }}>
        <h2 style={{ color: '#34495e', marginTop: '30px' }}>10. Changes to This Policy</h2>
        <p>
          We may update this Privacy Policy from time to time. When we do, we will:
        </p>
        <ul style={{ paddingLeft: '30px' }}>
          <li>Update the "Last updated" date at the top of this policy</li>
          <li>Notify users through app updates if changes are significant</li>
          <li>Continue to protect your privacy with the same high standards</li>
        </ul>
      </section>

      <section style={{ marginBottom: '30px' }}>
        <h2 style={{ color: '#34495e', marginTop: '30px' }}>11. Contact Us</h2>
        <p>
          If you have any questions or concerns about this Privacy Policy, please contact us at:
        </p>
        <div style={{ 
          backgroundColor: '#ecf0f1', 
          padding: '15px', 
          borderRadius: '8px', 
          marginTop: '15px' 
        }}>
          <p style={{ margin: '0' }}>
            <strong>Developer:</strong> [n1inovasyon]<br/>
            <strong>Email:</strong> [hi@n1inovasyon.com]<br/>
            <strong>Website:</strong> [www.n1inovasyon.com]
          </p>
        </div>
      </section>

      <section style={{ marginBottom: '30px' }}>
        <h2 style={{ color: '#34495e', marginTop: '30px' }}>12. Legal Compliance</h2>
        <p>
          This Privacy Policy complies with:
        </p>
        <ul style={{ paddingLeft: '30px' }}>
          <li>Apple App Store Review Guidelines</li>
          <li>Google Play Developer Policy</li>
          <li>COPPA (Children's Online Privacy Protection Act)</li>
          <li>GDPR (General Data Protection Regulation)</li>
          <li>CCPA (California Consumer Privacy Act)</li>
        </ul>
      </section>

      <div style={{ 
        borderTop: '1px solid #bdc3c7', 
        paddingTop: '20px', 
        marginTop: '40px',
        fontSize: '14px',
        color: '#7f8c8d',
        textAlign: 'center'
      }}>
        <p>
          <strong>Summary:</strong> Car Wash: Wash Simulator is a simple, offline game that collects no personal data. 
          We only display ads through Google AdMob, which has its own privacy practices. 
          Your game progress stays on your device and your privacy is fully protected.
        </p>
      </div>
    </div>
  );
};

export default CarWashPrivacy;